/**
 * 通勤費の非課税限度額と割増率。所得税法施行令・労働基準法が根拠。
 */

import type { StatutoryStandardTable } from '../../types';

/** 通勤費 非課税限度額表。交通手段 × 片道通勤距離に応じた 1 か月あたりの非課税限度額 */
export const commutingTaxExemptLimitTable: StatutoryStandardTable = {
  columns: [{
    label: '交通手段'
  }, {
    align: 'end',
    label: '片道距離 下限（以上）（km）'
  }, {
    align: 'end',
    label: '片道距離 上限（未満）（km）'
  }, {
    align: 'end',
    label: '非課税限度額（1 か月あたり）'
  }],
  rows: [['交通機関・有料道路', '—', '—', '1 か月の合理的な運賃等の額（上限 150,000 円）'], ['交通用具', '—', '2', '全額課税'], ['交通用具', '2', '10', '4,200 円'], ['交通用具', '10', '15', '7,300 円'], ['交通用具', '15', '25', '13,500 円'], ['交通用具', '25', '35', '19,700 円'], ['交通用具', '35', '45', '25,900 円'], ['交通用具', '45', '55', '32,300 円'], ['交通用具', '55', '65', '38,700 円'], ['交通用具', '65', '75', '45,700 円'], ['交通用具', '75', '85', '52,700 円'], ['交通用具', '85', '95', '59,600 円'], ['交通用具', '95', '—', '66,400 円'], ['交通用具 + 駐車場等（片道 2km 未満を除く）', '—', '—', '上記 + 駐車場等料金相当額（上限 5,000 円）'], ['通勤用定期乗車券', '—', '—', '1 か月の合理的な運賃等の額（上限 150,000 円）'], ['交通機関 + 交通用具の併用', '—', '—', '合理的な運賃等の額 + 交通用具分（上限 150,000 円）'], ['交通機関 + 交通用具 + 駐車場等の併用', '—', '—', '合理的な運賃等の額 + 交通用具分 + 駐車場等料金相当額（上限 5,000 円）（合計の上限 150,000 円）']]
};
/** 割増率表。割増種別に応じた法定最低率 */
export const premiumRateTable: StatutoryStandardTable = {
  columns: [{
    label: '割増種別'
  }, {
    align: 'end',
    label: '割増率（%）'
  }, {
    label: '根拠条文'
  }],
  rows: [['時間外労働（法定労働時間超・月60時間以内）', '25', '労基法37条1項＋割増賃金令'], ['時間外労働 月60時間超', '50', '労基法37条1項ただし書'], ['深夜労働（22時〜5時）', '25', '労基法37条4項'], ['法定休日労働', '35', '労基法37条1項＋割増賃金令'], ['時間外（月60時間以内）＋深夜', '50', '労基則20条1項'], ['時間外（月60時間超）＋深夜', '75', '労基則20条1項ただし書'], ['法定休日労働＋深夜', '60', '労基則20条2項']]
};